import services from './../../services/service'; // Service Class
import SecondHeader from './../Second-Header/index.vue'; // Second Header
import MainFooter from './../Main-Footer/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'ResetPassword',
    data () {
        return {
           user:{},
           disable_btn: false,
           forgot_processed:false,
           can_reset: false,
           can_login: false,
           is_not_valid: false
        }
    },
    components: {
        'second-header': SecondHeader,
        'main-footer': MainFooter
    },
    methods: {
        reset() {
            localStorage.removeItem("cityneeds_user");
            localStorage.removeItem("cityneeds_token");
            localStorage.removeItem("cityneeds_token_key");
            //remove session key here linked to session well @server
            let navi = this.$router;
            if(this.$route.query.resetPassword){
                service.verifyResetToken(this, this.$route.query.resetPassword).then(response => {
                    if(response.status == 200) {
                        this.can_reset = true;
                        this.user.user_id = response.body.data;
                    }
                }).catch((err) => {
                    toastr.warning("Authentication Failed", 'Warning!'); 
                    if(err.status == 400) {
                        this.is_not_valid = true;
                      }else{
                        navi.push('login');
                    }
                })
            }else{
                navi.push('login');
            }

        },

        resetPassword() {
            var credentials = {
                new_password: this.user.new_password,
                confirm_password: this.user.confirm_password,
                user: this.user.user_id
            }
            let navi = this.$router;
            if(credentials.new_password == '' || credentials.confirm_password == '' ) {
               toastr.warning("Kindly enter password", 'Warning!');
            }else if(credentials.new_password != credentials.confirm_password ) {
                toastr.warning("Passwords does not match", 'Warning!');
            }else {
                service.resetForgotPassword(this, credentials).then((response) => {
                    if(response.body.status == 200) {
                        this.can_reset = false;
                         this.can_login = true; 
                         toastr.success("Password has been Reset", 'Changed!'); 
                         navi.push('login');
                    }  
                   }).catch((err) => {
                    if(err.status == 404) {
                        toastr.warning("invalid credentials", 'Warning!'); 
                    }
                })
            }
        },
        

  },
  created: function() {
    this.reset();
  }
}


// WEBPACK FOOTER //
// ./src/components/ResetPassword/script.js